import { DetermineTextColor } from "../utils/DetermineTextColor";
import {
  enumDividerDirection,
  enumDragDropType,
  enumDropType,
  enumPanelBorderStyle,
  kDownArrow,
  kEscKey,
  kReturnKey,
  kTabKey,
  kUpArrow
} from "../constants";
import { uFramelessPanelColor } from "../whitelabel/brand";
//import { QBasicButton } from "./QBasicButton";
//import { QDivider } from "./QDivider";
import { QPanel } from "./QPanel";

export class QFramelessConfigPortPanel extends QPanel {
  constructor() {
    super();
  }

  InitPortPanel(parentPanel, roundBorders) {
    this.fBackgroundPanel = parentPanel;
    this.fWSMgr = parentPanel.fWSMgr;
    var panelFill = parentPanel.GetFillColor();
    this.SetFillColor(panelFill);
    if (roundBorders) {
      this.SetBorderThickness(2);
      this.SetBorderStyle(enumPanelBorderStyle.roundBorder);
      this.SetBorderRadius(4);
    }
    var parentZLayer = parentPanel.GetZLayer();
    this.SetZLayer(parentZLayer);
    this.fZPlanes = [];
  }

  GetDropInfo() {
    return this.fBackgroundPanel.GetDropInfo();
  }

  HandlePostDropUpload() {
    return this.fBackgroundPanel.HandlePostDropUpload();
  }

  MoveDropIndicator(targetElem, dropElem) {
    this.fBackgroundPanel.MoveDropIndicator(targetElem, dropElem);
  }

  ShiftExtendsSelection() {
    return this.fBackgroundPanel.ShiftExtendsSelection();
  }

  CtrlExtendsSelection() {
    return this.fBackgroundPanel.CtrlExtendsSelection();
  }

  SizePanel(hPort, vPort, hSize, vSize) {
    if (hSize == null) hSize = hPort;
    if (vSize == null) vSize = vPort;
    this.SizePanelAndPort(hSize, vSize, hPort, vPort);
  }

  IsPanelFrameless() {
    return true;
  }

  ExecuteCommand(aCmd) {
    return this.fBackgroundPanel.ExecuteCommand(aCmd);
  }

  SetCurrentTargetElement() {}

  SetSelectionList(theElementList) {
    this.fSelectionCache = theElementList;
  }

  GetSelectionCache() {
    if (this.fSelectionCache == null) this.fSelectionCache = [];

    return this.fSelectionCache;
  }

  PanelHandleKeyboard(keyInfo, targetElement, wsMgr) {
    var handled = true;
    var keyCode = keyInfo.keyCode;
    switch (keyCode) {
      case kTabKey:
        if (targetElement && targetElement.fParentHandleTabs)
          handled = this.fBackgroundPanel.PanelHandleKeyboard(keyInfo, targetElement, wsMgr);
        else this.TabToNextElement(!keyInfo.shiftKey, targetElement, wsMgr);
        break;
      case kReturnKey:
      case kEscKey:
      case kUpArrow:
      case kDownArrow:
        handled = this.fBackgroundPanel.PanelHandleKeyboard(keyInfo, targetElement, wsMgr);
        break;
      default:
        handled = false;
        break;
    }
    return handled;
  }

  DoHandleRightClick(hitElement, x, y) {
    return this.fBackgroundPanel.DoHandleRightClick(hitElement, x, y);
  }

  AddDivider(x, y, length, axis) {
    // var pos = axis === "x" ? enumDividerDirection.horzDivider : enumDividerDirection.vertDivider;
    // var aDivider = new QDivider();
    // aDivider.PositionElement(x, y);
    // aDivider.InitDivider(pos, 0, false);
    // aDivider.fFillStyle = DetermineTextColor(uFramelessPanelColor);
    // pos === 0 ? aDivider.SizeElement(length, 0.2) : aDivider.SizeElement(0.2, length);
    // this.PushElement(aDivider);
    // return aDivider;
  }

  GetDropType() {
    return this.fDropType;
  }

  SetDropMode(dropMode) {
    this.fDropMode = dropMode;
    this.fDropType = enumDropType.none;
    this.ClearDragOver();
  }

  InDropMode(dropMode) {
    return this.fDropMode;
  }

  DragOver(controlElement, theElement, x, y) {
    var controlYPosition = y;
    var hitElementY = this.GetPositionY() + theElement.GetPositionY() + theElement.GetHeight() / 2;

    // this is no good - replace these checks with button props
    //var isValid = theElement instanceof QBasicButton || theElement instanceof QDataCellElement;
    //if (!isValid) return;

    this.fDropType =
      controlYPosition < hitElementY ? enumDragDropType.above : enumDragDropType.below;
    theElement.fDropType = this.fDropType;
    this.fDropElement = theElement;
    this.DoSelectElement(theElement, true);
  }

  DoSelectElement(theElement, selectIt) {
    if (selectIt) this.AddToSelectionCache(theElement);
    else this.RemoveFromSelectionCache(theElement);
    this.PerformSelect(theElement, selectIt);
  }

  ClearDragOver() {
    this.fDropElement = null;
  }

  GetDragOver() {
    return this.fDropElement;
  }

  GetDragDropElement() {
    return this.fDropElement;
  }

  CustomShiftSelect(targetElement) {
    var selectionCache = this.GetSelectionCache();
    if (selectionCache.length === 0) return false;

    var elements = this.GetSelectableElements();
    var firstSelectedElem = this.GetFirstSelectedElement(null);

    var firstSelectedIndex = elements.indexOf(firstSelectedElem);
    var targetSelectedIndex = elements.indexOf(targetElement);

    // Used for grid with columns and rows
    //var lowerCol = Math.min(firstSelectedElem.fColumn, targetElement.fColumn);
    //var upperCol = Math.max(firstSelectedElem.fColumn, targetElement.fColumn);

    var lowerBound = Math.min(firstSelectedIndex, targetSelectedIndex);
    var upperBound = Math.max(firstSelectedIndex, targetSelectedIndex);

    for (var i = lowerBound; i <= upperBound; i++) {
      var includedElem = elements[i];
      this.DoSelectElement(includedElem, true);
    }

    return true;
  }
}
